import React from "react";
/** Larger chevron used in accordion section headers (24×24). */
export default function AccordionChevronIcon({ className }) {
    return (<svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.00134 17H3.41534L12.0013 8.414L20.5873 17H22.0013V15.586L12.4158 6H11.5883L2.00134 15.586V17Z" fill="currentColor"/>
    </svg>);
}
